var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{key:_vm.macroAnimation.ref,staticClass:"lottie-ani-handler no-flicker",style:({
    top: _vm.macroAnimation.position ? _vm.macroAnimation.position.top : 0,
    left: _vm.macroAnimation.position ? _vm.macroAnimation.position.left : 0,
    width: _vm.macroAnimation.width ? _vm.macroAnimation.width : null,
    height: _vm.macroAnimation.height ? _vm.macroAnimation.height : null
  }),attrs:{"id":_vm.macroAnimation.id}},[_c('lottie',{ref:"lottie",staticClass:"lottie-ani-handler__lottie-wrapper",on:{"animCreated":_vm.handleAnimation}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }